import { Accordion, AccordionSummary, AccordionDetails, Typography, Grid } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ClickEmoji from './emojis/ClickEmoji';

export const DataAccordion = ({ title, show, handleChange, children }) => {
    return (
        <Accordion
            expanded={show}
            onChange={handleChange}>
            <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
            >
                <Typography sx={{ color: '#212746', fontWeight: 'bold' }}>
                    {show
                        ? (
                            <>Click here <ClickEmoji />  to collapse {title}</>
                        )
                        : (
                            <>Click here <ClickEmoji /> to expand {title}</>
                        )}
                </Typography>
            </AccordionSummary>
            <AccordionDetails>
                <Grid item xs={12} display="flex" alignContent={'space-between'} flexWrap={'wrap'} mb={'1rem'}>
                    {children}
                </Grid>
            </AccordionDetails>
        </Accordion>
    )
}